module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "dialog"
  }, [_c('div', {
    staticClass: "dialog-inner"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    staticClass: "logo-img",
    attrs: {
      "src": "/dist/logo.svg"
    }
  }), _c('branch-label'), _c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$config.system_name))])], 1), _c('div', {
    staticClass: "ui piled segment form"
  }, [(_vm.showMessage) ? _c('div', {
    staticClass: "ui negative message visible"
  }, [_c('i', {
    staticClass: "close icon",
    on: {
      "click": _vm.dismiss
    }
  }), _c('div', {
    staticClass: "header"
  }, [_vm._v(_vm._s(_vm.messageHeader))]), _c('p', [_vm._v(_vm._s(_vm.message))])]) : _vm._e(), (_vm.timeout) ? _c('div', {
    staticClass: "ui warning message visible",
    on: {
      "click": function($event) {
        _vm.timeout = false
      }
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("已登出")]), _c('p', [_vm._v("长时间未操作，请重新登陆。")])]) : _vm._e(), (!_vm.server_available) ? _c('div', {
    staticClass: "ui negative message visible",
    on: {
      "click": function($event) {
        _vm.check_state()
      }
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("数据库未连接")]), _c('p', [_vm._v("点击重新连接，若多次尝试无效，请联系相关人员处理。")])]) : _vm._e(), (_vm.server_available) ? [_c('div', {
    staticClass: "ui field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    attrs: {
      "placeholder": "用户名"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "ui field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "密码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "ui field"
  }, [_c('div', {
    staticClass: "ui button themed",
    on: {
      "click": _vm.login
    }
  }, [_vm._v("登陆")])])] : _vm._e()], 2), (_vm.$native.supported) ? _c('div', {
    staticClass: "version"
  }, [_c('i', {
    staticClass: "icon checkmark"
  }), _vm._v("支持青柠檬宿本地调用插件")]) : _vm._e(), _c('div', {
    staticClass: "version"
  }, [_vm._v(_vm._s(_vm.version))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a4b90034","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/pages/Login.vue
// module id = 427
// module chunks = 0